export default class SubscriptionListSelectors {
  constructor(options, callback) {
    if (options?.el) {
      this.init(options, callback)
    }
  }

  init(options, callback) {
    this.list = typeof options.el === 'string' ? document.querySelector(options.el) : options.el
    this.callback = callback

    this.list.addEventListener('change', (e) => {
      const selectedLabel = document.querySelector(`label[for=${e.target.id}]`)
      const selectedLabelFor = selectedLabel.getAttribute('for')
      const productTitle = document.querySelector('.js-subscription-selector-list').getAttribute('data-product-title')

      let selectedSellingPlanId = ''
      if (selectedLabel.getAttribute('for') != 'frequency-one-time') {
        selectedSellingPlanId = $(selectedLabel).find(".js-delivery-cadence-selector option[selected='selected']").val()
      }

      if (window?.gtag) {
        window.gtag('event', 'Subscription Frequency Change', {
          event_detail: selectedLabelFor != 'frequency-one-time' ? 'Subscription' : 'One Time',
          event_detail2: productTitle,
        })
      }

      if (e.target.checked) {
        selectedLabel.setAttribute('aria-checked', 'true')
      }

      this.list.querySelectorAll('label').forEach((label) => {
        if (label !== selectedLabel) {
          label.setAttribute('aria-checked', 'false')
        }
      })

      this.callback({
        target: e.target,
        selectedSellingPlanId: selectedSellingPlanId,
      })
    })

    // Trigger change event on the checked radio button
    const checkedRadio = this.list.querySelector('input[type="radio"]:checked')
    if (checkedRadio) {
      const event = new Event('change', { bubbles: true })
      checkedRadio.dispatchEvent(event)
    }
  }
}
